<template>
  <v-app>
    <dashboard-core-app-bar />
    <v-progress-linear
      v-show="load"
      indeterminate
      color="#E72480"
    ></v-progress-linear>
    <dashboard-core-drawer />

    <dashboard-core-view />

  </v-app>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {getUsers} from "../../api/users";
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
    computed:{
      ...mapGetters({
        load : 'get_loading',

      })
    },
    mounted() {
      // getUsers(1,4)
    }
  }
</script>
